<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE FAR REACHES</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="cpytxt"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="cpytxt1"><span class="smallcaps">THOMAS DUNNE BOOKS</span>.<br/>An imprint of St. Martin’s Press.</p>
<p class="cpytxt1"><span class="smallcaps">THE FAR REACHES</span>. Copyright © 2007 by Homer Hickam. All rights reserved.<br/>Printed in the United States of America.<br/>No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="cpytxt1"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a><br/><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="cpytxt2">Library of Congress Cataloging-in-Publication Data</p>
<p class="cpytxt2">Hickham, Homer H., 1943</p>
<p class="cpytxt3">The far reaches / Homer Hickam.—1st ed.</p>
<p class="cpytxt3">   p. cm.</p>
<p class="cpytxt3">ISBN-13: 978-0-312-33475-8</p>
<p class="cpytxt3">ISBN-10: 0-312-33475-3</p>
<p class="cpytxt3">1. United States. Marine Corps—Fiction. 2. World War, 1939-1945—Campaigns—Pacific Area—Fiction.</p>
<p class="cpytxt4">PS3558.I224 F37 2007<br/>813'.54—dc22                  2007010369</p>
<p class="centercpy">First Edition: June 2007</p>
<p class="centercpy">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2d9c293c